import template from "./pCasemanClientConfig.html";

export function pCasemanClientConfigDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: pCasemanClientConfigController,
    controllerAs: 'pCasemanClientConfig',
    bindToController: true
  };

  return directive;
}

class pCasemanClientConfigController {
  constructor($scope, $location, $interval, $q, Auth, Caseman, Notes, Sort, Utils, ConnectionQuality) {
    'ngInject';
    this.$scope = $scope;
    this.$location = $location;
    this.$interval = $interval;
    this.$q = $q;
    this.Auth = Auth;
    this.Caseman = Caseman;
    this.Notes = Notes;
    this.Sort = Sort;
    this.Utils = Utils;
    this.ConnectionQuality = ConnectionQuality;
    this.state = "loading";
    this.matchBlocked = false;
    this.showOnlyActive = true;
    this.activeClientsKlix = [];

    this.headers = [
      {name: "CASEMAN.CLIENT_KLIX", class: "table-info"},
      {name: "CASEMAN.PROJECT_CASEMAN", class: "table-caseman"}
    ];

    this.Auth.authorize().then(
      (user) => {
        this.user = user;
        //Notes...
        const timeout = this.$interval(() => {this.notes = this.Notes.getNotes();}, 200);
        this.$scope.$on("$destroy", () => {this.$interval.cancel( timeout );});

        let promises = [
          this.Caseman.getCountryClients(),
          this.Caseman.getCountryClientMappers(),
        ];

        this.$q.all(promises).then(
          (success) => {
            this.clientsKlix = success[0].data.sort(this.Sort.abcBy("name"));
            this.activeClientsKlix = this.clientsKlix.filter(client => client.isActive);
            this.clientsMapper = success[1].data;

            this.mapperToDisplay = this.getMapperToDisplay(this.activeClientsKlix);

            this.state = "loaded";
          },
          (error) => {
            this.state = "error";
            this.Notes.postNote({type: "error", error: error});
          }
        );

        this.Caseman.getCountryCasemanProjects().then(
          (success) => {
            if(success.data.length == 0 || !success.data) {
              this.noProjects = true;
              this.projectsCASEMAN = [];
            } else {
              this.projectsCASEMAN = success.data.sort(this.Sort.abcBy("name")).map((project)=> {
                project.info = project.country + " - " + project.name;
                return project;
              } );
            }
          },
          (error) => {
            this.state = "error";
            this.Notes.postNote({type: "error", error: error});
          }
        );
      },
      () => {
        this.Auth.handleUnauthorized();
      }
    );

    $scope.$on('connectionQualityChanged', () => {
      if (this.ConnectionQuality.isSlow) {
        this.Notes.postNote({
          type: 'slowConnection',
          manualHide: true
        });
      }
      else {
        const note = this.Notes.getNotes().find(note => note.type === 'slowConnection' && note.active);
        if (note)
          this.Notes.hide(note);
      }
    });
  }

  getMapperToDisplay(klixClients) {
    const mapperToDisplay = klixClients && klixClients.map(clientKlix => {
      let client = this.clientsMapper && this.clientsMapper.find(clientMapper => clientMapper.clientId == clientKlix.id);
      if(!client) {
        client = {
          clientId: clientKlix.id,
          clientName: clientKlix.name,
          isActive: clientKlix.isActive,
          projectId: null,
          projectName: null,
          casemanCountry: null,
          unmatched: true
        };
      }

      if (clientKlix.additonalInfo)
        client.nameWithAdditionalInfo = `(${clientKlix.additonalInfo}) ${clientKlix.nameWith}`;
      return client;
    });
    return mapperToDisplay;
  }

  refresh() {
    this.Caseman.getCountryClientMappers().then(
      (success) => {
        this.clientsMapper = success.data;
        this.toggleActive();
        this.matchBlocked = this.Utils.blockMatch(this.mapperToDisplay);
        this.state = "loaded";
      },
      (error) => {
        this.state = "error";
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  back() {
    window.history.back();
  }

  editClient(entity) {
    this.matchBlocked = this.Utils.blockMatch(this.mapperToDisplay);
    this.clientToMatch = {id: entity.projectId, name: entity.projectName, country: entity.casemanCountryCode, info: entity.projectName };
    this.hintClient = entity.clientName.substr(0,entity.clientName.indexOf(' ')+1);
  }

  saveClientMatch(client, projectToMatch) {
    this.state = "loading";
    this.Caseman.setClientMapper(client.clientId, angular.fromJson(projectToMatch).id, angular.fromJson(projectToMatch).country).then(
      () => {
        this.clientToMatch = null;
        this.refresh();
      },
      (error) => {
        this.state = "error";
        this.matchBlocked = this.Utils.blockMatch(this.mapperToDisplay);
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  deleteClient(client) {
    this.state = "loading";
    this.Caseman.deleteClientMapper(client.clientId).then(
      () => {this.refresh();},
      (error) => {
        this.state = "error";
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  cancel() {
    this.matchBlocked = this.Utils.blockMatch(this.mapperToDisplay);
    this.clientToMatch = null;
  }

  toggleActive() {
    if (this.showOnlyActive) {
      this.mapperToDisplay = this.getMapperToDisplay(this.activeClientsKlix);
    } else {
      this.mapperToDisplay = this.getMapperToDisplay(this.clientsKlix);
    }
  }
}
